export const bannerShell = "relative w-full overflow-hidden bg-neutral-900";
export const bannerFrame =
  "relative w-full h-[280px] sm:h-[360px] md:h-[500px] shrink-0 overflow-hidden bg-neutral-900";
export const bannerImage =
  "absolute inset-0 h-full w-full object-cover object-center";
/** Inner pages — full banner graphic, no fixed crop height */
export const pageBannerFrame =
  "relative w-full shrink-0 overflow-hidden bg-neutral-900";
export const pageBannerImage = "block w-full h-auto";
export const bannerGradient =
  "absolute inset-0 bg-gradient-to-t from-black/55 via-black/5 to-transparent pointer-events-none";
export const bannerTitleWrap =
  "absolute bottom-0 left-0 right-0 z-10 px-4 pb-14 sm:px-6 sm:pb-8 md:px-10 md:pb-10 pointer-events-none";
export const bannerTitleInner = "w-full px-4";
export const bannerTitle =
  "text-xl sm:text-2xl md:text-3xl lg:text-4xl font-bold text-white tracking-tight leading-snug drop-shadow-md max-w-[calc(100%-3rem)] md:max-w-none";
